import React from 'react';
import { AlertCircle, UserX, CalendarX, HelpCircle } from 'lucide-react';

export const PainMock: React.FC = () => {
  return (
    <div className="bg-white rounded-xl border border-red-100 shadow-sm overflow-hidden max-w-2xl mx-auto">
      {/* Mock Header */}
      <div className="bg-red-50/50 px-4 py-3 border-b border-red-100 flex items-center justify-between">
        <div className="flex items-center gap-2">
          <div className="w-2 h-2 rounded-full bg-red-400 animate-pulse"></div>
          <span className="text-xs font-semibold text-red-900 uppercase tracking-wide">Status: Bloqueado</span>
        </div>
        <span className="text-xs text-red-400">Reunião de Segunda-feira</span>
      </div>

      {/* Mock Table Body */}
      <div className="p-0">
        <div className="grid grid-cols-12 gap-0 text-sm">
          
          {/* Header Row */}
          <div className="col-span-12 grid grid-cols-12 px-6 py-2 bg-slate-50 border-b border-slate-100 text-xs font-medium text-muted">
            <div className="col-span-6">O que foi falado</div>
            <div className="col-span-3">Quem vai fazer?</div>
            <div className="col-span-3">Para quando?</div>
          </div>

          {/* Row 1 */}
          <div className="col-span-12 grid grid-cols-12 px-6 py-4 items-center hover:bg-red-50/30 transition-colors">
            <div className="col-span-6 pr-4">
              <div className="font-medium text-ink">Atualizar preços no site</div>
              <div className="text-xs text-muted mt-1">Mencionado por @Carlos aos 15min</div>
            </div>
            
            <div className="col-span-3">
              <div className="flex items-center gap-1.5 text-red-600 bg-red-50 w-fit px-2 py-1 rounded border border-red-100">
                <UserX size={12} />
                <span className="text-xs font-bold">Ninguém</span>
              </div>
            </div>
            
            <div className="col-span-3">
               <div className="flex items-center gap-1.5 text-red-600 bg-red-50 w-fit px-2 py-1 rounded border border-red-100">
                <CalendarX size={12} />
                <span className="text-xs font-bold">Sem data</span>
              </div>
            </div>
          </div>

          {/* Row 2 */}
          <div className="col-span-12 grid grid-cols-12 px-6 py-4 items-center border-t border-slate-50 hover:bg-slate-50/50 transition-colors">
            <div className="col-span-6 pr-4">
              <div className="font-medium text-ink">Contratar freelance</div>
              <div className="text-xs text-muted mt-1">Depende da aprovação do budget?</div>
            </div>
            
            <div className="col-span-3">
               <div className="flex items-center gap-1.5 text-amber-600">
                <HelpCircle size={14} />
                <span className="text-xs">Marketing?</span>
              </div>
            </div>
            
             <div className="col-span-3">
               <span className="text-xs text-muted">A definir</span>
            </div>
          </div>

        </div>
      </div>
      
      {/* Alert Footer */}
      <div className="bg-red-50 px-4 py-3 flex items-start gap-3 border-t border-red-100">
        <AlertCircle size={16} className="text-red-600 mt-0.5" />
        <p className="text-xs text-red-800 leading-relaxed">
          <span className="font-bold">Alerta:</span> Estas decisões serão esquecidas em 48 horas se não forem registradas agora.
        </p>
      </div>
    </div>
  );
};